__webpack_require__.p = "/lapiscine/";